import { ViewController, JsonFeed, ModelUpdateEvent, DataReceiveEvent, MaintenanceEvent, CustomerIntegrationController,
         VideoReloadEvent, TimeUpdateEvent, ChannelSwitchEvent, BetPlaceEvent, TimeoutEvent } from "@gaming/srvg-classes-core";
import { TerminalCompactView } from "../../View/AppView/TerminalCompactView";
import { TitlebarController } from "./TitlebarController";
import { VideoController } from "./VideoController";
import { TimelineController } from "../TimelineController";
import { MatchIdsFeedController } from "../MatchIdsFeedController";
import { MatchdayAreaController } from "./MatchdayAreaController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class TerminalCompactViewController extends ViewController {
    webView: TerminalCompactView;

    titlebarController: TitlebarController;
    videoController: VideoController;
    matchdayAreaController: MatchdayAreaController;

    constructor( options ) {
        options = options || {};
        options.view = options.webView || null;
        super( options );
        this.name = 'vblWebViewController';

        this.webView = options.webView || null;

        /******************* initialize controllers ************************/

        this.videoController = this.addChildViewController( new VideoController( {
            videoView: this.webView.videoView,
            videoControlBar: null,
            channel: srvg.videooptions.defaultchannel
        } ) );

        app.timelineController       = new TimelineController( { url: srvg.url.timeline } );
        app.matchIdsFeedController = new MatchIdsFeedController( {
            feed: new JsonFeed( { url: srvg.url.matchidsfeed } ),
            maxSize: 60
        } );
        this.titlebarController       = this.addChildViewController( new TitlebarController( { titlebar: this.webView.titlebar } ) );
        app.customerIntegration       = new CustomerIntegrationController( {} );
        srvg.customerIntegration = app.customerIntegration;

        this.matchdayAreaController = this.addChildViewController( new MatchdayAreaController({
            matchdayArea: this.webView.matchdayArea
        }) );

        /******************* connect components ************************/

        if( this.webView.matchdayArea.matchdayPicker ) {
            // FIXME move
            this.webView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.customerIntegration, ModelUpdateEvent );
        }
        this.webView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.matchIdsFeedController, ModelUpdateEvent );
        app.matchIdsFeedController.addSubscriberForEvent( app.customerIntegration, DataReceiveEvent );

        app.timelineController.addSubscriberForEvent( srvg.maintenance, MaintenanceEvent );

        app.timelineController.addSubscriberForEvent( app.customerIntegration,    PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( this.titlebarController,    PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( app.server,                 TimeUpdateEvent );
        app.timelineController.addSubscriberForEvent( this.videoController,       VideoReloadEvent );

        app.inactivityController.addSubscriberForEvent( this.titlebarController, TimeoutEvent );
        app.inactivityController.addSubscriberForEvent( app.timelineController,  TimeoutEvent );
        app.inactivityController.addSubscriberForEvent( this.videoController,    TimeoutEvent );
        app.inactivityController.addSubscriberForEvent( app.customerIntegration, TimeoutEvent );

        this.webView.matchdayArea.oddsGallery.addSubscriberForEvent( app.customerIntegration, BetPlaceEvent );

        var exch = srvg.eventExchange;

        // TODO replace eventType strings with event classes

        //___________________eventSubscriber____________________eventProvider_______________eventType___________eventHandler_________________


        exch.addEventHandler(this.videoController,             'all',                          ChannelSwitchEvent );
        exch.addEventHandler(app.customerIntegration,          'all',                          ChannelSwitchEvent );

        /******************* start components ************************/
        app.timelineController.startPolling();
        this.videoController.play();
        app.customerIntegration.startCustomerActions();


        // force reload
        // activate for all retail instances
        if (srvg.featuresInstances.getEnableForceReloadFullRetail()){
            srvg.flost.setForceReloadCompatibleWithMinute( srvg.featuresInstances.getForceReload() );
        }else{
            // activate only for flost
            if( srvg.videooptions.flostVideosets ) {
                srvg.flost.setForceReloadCompatibleWithMinute( srvg.featuresInstances.getForceReload() );
            }
        }

    }
}